<app-pills-overflow
  class="w-full min-w-0"
  [items]="pillItems()"
  [maxRows]="3"
  [pillHeight]="24"
  [gapSize]="6"
  (pillClick)="onPillClick($any($event))">
  <ng-template #pillTemplate let-item let-clickable="false" let-onClick="onClick">
    @if (clickable) {
      <button
        type="button"
        class="inline-flex max-w-full min-w-0 cursor-pointer rounded-full transition-transform hover:scale-105 active:scale-95"
        (click)="onClick(item)">
        <app-label-pill [k]="item.data.key" [v]="formatValue(item.data.value)" />
      </button>
    } @else {
      <app-label-pill [k]="item.data.key" [v]="formatValue(item.data.value)" />
    }
  </ng-template>
</app-pills-overflow>
